import React from 'react';
import styled from 'styled-components';
import Aos from 'components/LV1/Aos';
import Image from 'components/LV1/image';
import ServiceInfo from 'components/LV2/ServiceInfo';

const ServiceImageWrap = styled.div`
  width: 100%;
  z-index: 1;
  padding: 120px 0;
  &:last-child {
    padding: 120px 0 0;
  }
  &.bg-white {
    background-color: #fff;
  }
  .inner {
    position: relative;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    z-index: 1;
  }
  p.num {
    position: absolute;
    top: -32px;
    left: 32px;
    font-size: 4.8rem;
    letter-spacing: 0.1em;
    font-family: 'Marcellus',serif;
  }
  .service-info-wrap {
    padding: 0 15px;
  }
  ${props => props.theme.media.tab} {
    p.num {
      left: 16px;
    }
  }
`;

type Props = {
  isBgWhite?: boolean;
  num: string;
  title: string;
  titleSub: string;
  description: string;
  imgPath: string;
  imgAlt: string;
  list: {
    title: string;
    text: any;
  }[];
};

const ServiceInfoSet: React.FC<Props> = (props: Props) => {
  const { isBgWhite, num, title, titleSub, description, imgPath, imgAlt, list } = props;
  return (
    <ServiceImageWrap className={isBgWhite ? "bg-white" : ""}>
      <div className="inner">
        <Aos>
          <Image filename={`services/${imgPath}`} alt={imgAlt} />
          <p className="num">{num}</p>
        </Aos>
        <div className="service-info-wrap">
          <ServiceInfo
            title={title}
            titleSub={titleSub}
            description={description}
            list={list}
          />
        </div>
      </div>
    </ServiceImageWrap>
  );
};
export default ServiceInfoSet;
